(function() {
  'use strict';

  angular.module('app').factory('TaxesExemptInCorporateService', TaxesExemptInCorporateService);

  TaxesExemptInCorporateService.$inject = [
    '$rootScope',
    'API',
    '$filter',
    'CorporateCustomerService',
    'NotifyService',
    'blockUI',
    '$uibModal'];

  function TaxesExemptInCorporateService(
      $rootScope,
      API,
      $filter,
      CorporateCustomerService,
      NotifyService,
      blockUI,
      $uibModal
  ) {
    var service = {};
    /**
     *
     * @param {object} params
     * @param {object} params.corporateCustomerSpecialAccount
     * @param {object} params.corporateCustomer
     * @param {object} params.corporateCategory
     * @constructor
     */
    service.TaxesExempt = function(params) {

      if (!params.corporateCustomerSpecialAccount) {
        return false;
      }
      if (!params.corporateCustomer && !params.corporateCategory) {
        return false;
      }

      var UpdateTaxesCorporateCustomerSpecialAccount = function(taxesExempt, callback) {
        if (params.corporateCustomer) {
          CorporateCustomerService.UpdateTaxesCorporateCustomerSpecialAccount(
              params.corporateCustomer.id,
              params.corporateCustomerSpecialAccount.id,
              taxesExempt,
              callback
          );
        } else if (params.corporateCategory) {
          CorporateCustomerService.UpdateTaxesCorporateCategoryCustomerSpecialAccount(
              params.corporateCategory.id,
              params.corporateCustomerSpecialAccount.id,
              taxesExempt,
              callback
          );
        } else {
          callback(false);
        }
      };
      var GetTaxesCorporateCustomerSpecialAccount = function(callback) {
        if (params.corporateCustomer) {
          CorporateCustomerService.GetTaxesCorporateCustomerSpecialAccount(
              params.corporateCustomer.id,
              params.corporateCustomerSpecialAccount.id,
              callback
          );
        } else if (params.corporateCategory) {
          CorporateCustomerService.GetTaxesCorporateCategoryCustomerSpecialAccount(
              params.corporateCategory.id,
              params.corporateCustomerSpecialAccount.id,
              callback
          );
        } else {
          callback(false);
        }
      };
      var GetTaxesItemsCorporateCustomerSpecialAccount = function(qParams, callback) {
        if (params.corporateCustomer) {
          CorporateCustomerService.GetTaxesItemsCorporateCustomerSpecialAccount(
              params.corporateCustomer.id,
              params.corporateCustomerSpecialAccount.id,
              qParams,
              callback);
        } else if (params.corporateCategory) {
          CorporateCustomerService.GetTaxesItemsCorporateCategoryCustomerSpecialAccount(
              params.corporateCategory.id,
              params.corporateCustomerSpecialAccount.id,
              qParams,
              callback);
        } else {
          callback(false);
        }
      };

      var UpdateTaxesItemsCorporateCustomerSpecialAccount = function(data, callback) {
        if (params.corporateCustomer) {
          CorporateCustomerService.UpdateTaxesItemsCorporateCustomerSpecialAccount(
              params.corporateCustomer.id,
              params.corporateCustomerSpecialAccount.id,
              data,
              callback);
        } else if (params.corporateCategory) {
          CorporateCustomerService.UpdateTaxesItemsCorporateCategoryCustomerSpecialAccount(
              params.corporateCategory.id,
              params.corporateCustomerSpecialAccount.id,
              data,
              callback);
        } else {
          callback(false);
        }
      };

      var block_ui_modal = blockUI.instances.get('taxes-modal');
      $uibModal.open({
        animation: true,
        keyboard: true,
        backdrop: 'static',
        size: 'lg',
        templateUrl: 'app/pages/corporates/taxes-exempt-in-corporate/corporate-user.taxes.modal.html',
        controllerAs: 'popup',
        windowTopClass: 'modal-center',
        controller: function($uibModalInstance) {
          var popup = this;

          popup.taxesItemsParams = {
            page: 1,
            count: 10
          };

          popup.corporateCustomerSpecialAccount = params.corporateCustomerSpecialAccount;
          popup.taxes = [];
          popup.taxesItems = [];

          var onChangeExemptState = [];
          popup.onChangeExempt = function(tax) {
            var indexState = onChangeExemptState.indexOf(tax.tax_id);
            if (indexState === -1) {
              onChangeExemptState.push(tax.tax_id);
            } else {
              onChangeExemptState.splice(indexState, 1);
            }
          };

          function confirmationPopup(type, save, changeTab, tab) {
            return $uibModal.open({
              animation: true,
              keyboard: true,
              size: 'sm',
              templateUrl: 'app/templates/modal.confirmation.html',
              controllerAs: 'popup',
              controller: function($uibModalInstance) {
                var popup = this;
                popup.type = type;
                popup.onSaveClick = function(exit) {
                  save(function() {
                    changeTab(tab);
                  });
                  $uibModalInstance.close();
                };

                popup.onCancelClick = function(exit) {
                  $uibModalInstance.close();
                };
              }
            });
          }

          popup.onChangeTab = function(tabName) {
            if (onChangeExemptState.length > 0) {
              // TODO show confirm to save changes
              confirmationPopup('save', function(callback) {
                popup.saveTaxes(callback);
                onChangeExemptState = [];
              }, popup.onChangeTab, tabName);
              return;
            }

            block_ui_modal.start();
            switch (tabName) {
              case 'taxes':
                refreshTaxes(function() {
                  block_ui_modal.stop();
                });
                break;
              case 'taxes-on-items':
                onChangeExemptState = [];
                popup.taxesItemsParams = {
                  page: 1,
                  count: 10
                };
                refreshTaxesItems(function() {
                  block_ui_modal.stop();
                });
                break;
            }
            popup.currentTab = tabName;
          };

          popup.onChangeTab('taxes');

          popup.getPages = getTotalPaginatedPages;
          popup.pager_count = [10, 20, 50, 100, 200];

          popup.onCountChange = function(count) {
            block_ui_modal.start();

            popup.taxesItemsParams.page = 1;
            popup.taxesItemsParams.count = count;

            refreshTaxesItems(function() {
              block_ui_modal.stop();
            });

          };
          popup.pageChange = function() {
            block_ui_modal.start();
            refreshTaxesItems(function() {
              block_ui_modal.stop();
            });
          };

          popup.popupItemTaxes = function(item) {
            var block_ui_modal_item = blockUI.instances.get('taxes-modal-item'); // TODO
            $uibModal.open({
              animation: true,
              keyboard: true,
              backdrop: 'static',
              size: 'lg',
              templateUrl: 'app/pages/corporates/taxes-exempt-in-corporate/item-taxes.html',
              controllerAs: 'popup',
              windowTopClass: 'modal-center',
              controller: function($uibModalInstance) {
                var popupItem = this;
                popupItem.item = item;
                console.log('popupItem.item ', popupItem.item);

                popupItem.saveItemTaxes = function(callback) {
                  block_ui_modal_item.start();

                  saveItemTaxes(function(success) {
                    if (success) {
                      NotifyService.Success('', false);
                    }
                    if (callback) {
                      callback(success);
                    }
                    block_ui_modal_item.stop();
                  });

                };

                popupItem.saveItemTaxesAndClose = function() {
                  popupItem.saveItemTaxes(function(success) {
                    if (success) {
                      popupItem.closeModal();
                    }
                  });
                };
                popupItem.closeModal = function() {
                  $uibModalInstance.close();
                  block_ui_modal.start();
                  refreshTaxesItems(function() {
                    block_ui_modal.stop();
                  });
                };

                function saveItemTaxes(callback) {
                  var item = angular.copy(popupItem.item);
                  UpdateTaxesItemsCorporateCustomerSpecialAccount([item], function(success, data) {
                    // if (success) {
                    //   popup.taxes = data;
                    // }
                    if (callback) {
                      callback(success, data);
                    }
                  });
                  // CorporateCustomerService.UpdateTaxesItemsCorporateCustomerSpecialAccount(
                  //     corporateCustomerId,
                  //     corporateCustomerSpecialAccount.id,
                  //     [item],
                  //     function(success, data) {
                  //       // if (success) {
                  //       //   popup.taxes = data;
                  //       // }
                  //       if (callback) {
                  //         callback(success, data);
                  //       }
                  //     });
                }
              }
            });
          };

          popup.saveTaxes = function(callback) {
            block_ui_modal.start();
            saveTaxes(function(success) {
              if (success) {
                NotifyService.Success('', false);
              }
              if (callback) {
                callback(success);
              }
              block_ui_modal.stop();
            });
          };

          popup.saveTaxesAndClose = function() {
            popup.saveTaxes(function(success) {
              if (success) {
                popup.closeModal();
              }
            });
          };

          popup.closeModal = function(exit) {
            $uibModalInstance.close();
          };

          function saveTaxes(callback) {
            var taxes = angular.copy(popup.taxes);
            UpdateTaxesCorporateCustomerSpecialAccount(taxes, function(success, data) {
              if (success) {
                popup.taxes = data;
              }
              if (callback) {
                callback(success, data);
              }
            });
            // CorporateCustomerService.UpdateTaxesCorporateCustomerSpecialAccount(
            //     corporateCustomerId,
            //     corporateCustomerSpecialAccount.id,
            //     taxes,
            //     function(success, data) {
            //       if (success) {
            //         popup.taxes = data;
            //       }
            //       if (callback) {
            //         callback(success, data);
            //       }
            //     });
          }

          function refreshTaxes(callback) {
            popup.taxes = [];
            GetTaxesCorporateCustomerSpecialAccount(function(success, data) {
              if (success) {
                popup.taxes = data;
              }
              if (callback) {
                callback(success, data);
              }
            });
            // CorporateCustomerService.GetTaxesCorporateCustomerSpecialAccount(
            //     corporateCustomerId,
            //     corporateCustomerSpecialAccount.id, function(success, data) {
            //       if (success) {
            //         popup.taxes = data;
            //       }
            //       if (callback) {
            //         callback(success, data);
            //       }
            //     });
          }

          function refreshTaxesItems(callback) {
            // popup.taxesItems = [];
            var params = angular.copy(popup.taxesItemsParams);
            GetTaxesItemsCorporateCustomerSpecialAccount(params, function(success, data) {
              if (success) {
                popup.taxesItems = data;
              }
              if (callback) {
                callback(success, data);
              }
            });
          }
        }
      });
    };

    return service;
  }

})();

